import axios from "axios";

const api = axios.create({
 //baseURL: "http://localhost:4000",
 // baseURL: "http://10.121.177.220:4000",
  baseURL: "https://api.ethiob2b.com/",
  //baseURL: "http://192.168.8.26:4000"
});

export default api;
